import React, { Component } from 'react';

const subtitle = "What our Clients Say";
const title = "Client’s Feed back Latest Reviews";

let ClientsListContent =[
    {
        Desc: "\"Tegal eased my partner's way into my life. Tegal was inevitable getting someone that checks out my steep " +
            "criterion so good\"",
        Name: 'Rabiu Aliyu',
        Digi: 'UI Designer',
        imgAlt: 'Client Thumb',
    },
    {
        Desc: "\"I am living the dream. They say perfect partners are impossible to find. Tegal proved them all wrong\"",
        Name: 'Ummi Nishat',
        Digi: 'Founder',
        imgAlt: 'Client Thumb',
    },
    {
        Desc: "\"There are heartbroken people out there, looking for soothing shoulders to lean on. Tegal made my dream come true.\"",
        Name: 'Somrat Islam',
        Digi: 'UI Designer',
        imgAlt: 'Client Thumb',
    },
    {
        Desc: 'Tegal should be renamed to \'True love\'.',
        Name: 'Umar Nuhu Abba',
        Digi: 'Student',
        imgAlt: 'Client Thumb',
    },
    {
        Desc: 'I have never trusted match-making platforms because I find their data protection inept. I am a private person, so it is important to me. Tegal protects my privacy. I simply trust them',
        Name: 'Umar Ahmad',
        Digi: 'UI Designer',
        imgAlt: 'Client Thumb',
    },
    {
        Desc: 'If not for Tegal, my indecisiveess would have left me single forever.',
        Name: 'Kehinde Adetimilehin',
        Digi: 'UI Designer',
        imgAlt: 'Client Thumb',
    },
]




class ClientSection extends Component {
    state = {  } 
    render() { 
        return (
            <section className="clints-section padding-tb">
                <div className="container">
                    <div className="section-header">
                        <h4 className="theme-color">{subtitle}</h4>
                        <h2>{title}</h2>
                    </div>
                    <div className="section-wrapper">
                        <div className="clients">
                            {ClientsListContent.map((val, i) => (
                                <div className="client-list" key={i}>
                                    <div className="client-content">
                                        <p> {val.Desc} </p>
                                        <div className="client-info">
                                            <div className="name-desi">
                                                <h6>{val.Name}</h6>
                                                <span>{val.Digi}</span>
                                            </div>
                                            <div className="rating">
                                                <ul>
                                                    <li><i className="icofont-star"></i></li>
                                                    <li><i className="icofont-star"></i></li>
                                                    <li><i className="icofont-star"></i></li>
                                                    <li><i className="icofont-star"></i></li>
                                                    <li><i className="icofont-star"></i></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="client-thumb">
                                     {val.Name}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
 
export default ClientSection;